import { useMutation, useQueryClient } from "@tanstack/react-query";
import { baseDocumentsQueryKey } from "src/config/request-keys";
import { saveChatAttachmentToEqms } from "src/services/backend";
import { invalidateCachedDashboardQueries } from "./queries/dashboard-invalidation";

export const useSaveChatAttachmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveChatAttachmentToEqms,
    networkMode: "always",
    retry: false,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: baseDocumentsQueryKey });
      void invalidateCachedDashboardQueries(queryClient);
    },
  });
};
